<template>
    <div class="chatContainer">
        <v-list two-line>
            <v-list-item-group active-class="activeChat">
                <v-list-item
                        v-for="item in items"
                        :key="item.chatId"
                        active-class="activeChat"
                        class="chat-item"
                        @click="selectChat($event, item)"
                >
                    <template v-slot:default="{ active, toggle }">
                        <v-list-item-content>
                            <v-list-item-title>
                                <span class="order-number">{{'№'+item.requestNumber+' '}}</span> •
                                <span class="client-name">{{item.clientName}}</span> •
                                <span>{{item.carMarkName+' '+item.carModelName+', '+item.carYear}}</span>
                            </v-list-item-title>
                            <v-list-item-subtitle v-text="item.lastMessasge"
                                                  :class="{'active-chat-item':active,'sub-text':true}"></v-list-item-subtitle>
                        </v-list-item-content>

                        <v-list-item-action>
                            <v-list-item-action-text>
                                <span style="opacity: 0.7;" :class="{'active-chat-item':active,'sub-text':true}">{{formatDate(item.lastMessageDateTime)}}</span>
                            </v-list-item-action-text>
                            <v-list-item-action-text>
                                <v-badge
                                        v-if="item.countNotReadChatMessage>0"
                                        inline
                                        color="var(--color-red)"
                                        :content="'+ '+item.countNotReadChatMessage"
                                >
                                </v-badge>
                            </v-list-item-action-text>
                        </v-list-item-action>
                    </template>
                </v-list-item>
            </v-list-item-group>
        </v-list>
    </div>
</template>

<script>
    export default {
        name: "OrdersList",
        props:{
            items:Array
        },
        methods:{
            selectChat(event, item) {
                this.$emit("selectionChange", item)
            },
        }
    }
</script>

<style scoped>
    .chatContainer{
        overflow-y: scroll;
        overflow-x: hidden;
        height: 100%;
    }
    .chat-item{
        height: 70px;
        border-bottom: 1px solid #EFF2FC;
        font-size: 16px;
        line-height: 20px;
    }
    .activeChat{
        color:white !important;
        background: #0156AD
    }
    .order-number{
        font-weight: bold;

    }

    .v-list-item:not(.activeChat)>.v-list-item__content >.v-list-item__title > .order-number{
        color:var(--color-blue)
    }

    .client-name{
        font-weight: bold;
    }

    .v-list-item.activeChat>.v-list-item__content >.v-list-item__title{
        font-weight: bold;
    }

    .sub-text.active-chat-item{
        opacity: 0.8;
        color: white !important;
    }

    .sub-text{
        margin-top: 4px;
        font-weight: 500;
        font-size: 14px;
        color:#6E7C8D;
    }

</style>